module.exports = __webpack_public_path__ + "static/media/bid-for-placement.d0bc1c15.svg";